import { Button, Modal, Statistic, Row, Col } from 'antd';
import React, { useState } from 'react';
import moment from 'moment';
import Widget from "components/Widget/index";
import { getData, createData } from '../../util/API';
import { message } from "antd/lib/index";


const PunchIn = () => {
    return (
        <Widget styleName="gx-card-full gx-text-center gx-pt-4 gx-pb-3 gx-px-3">
            {/* <div className="gx-separator gx-bg-sepia" /> */}
            <h2 className="gx-mb-2 ">{moment().format('HH:mm A')}</h2>
            <p className="gx-text-grey gx-mb-2">{moment().format('DD MMMM YYYY')}</p>

            <Button type='primary' onClick={logAttendence('punch_in')}>
                Punch In
            </Button>
        </Widget>
    );
};

const PunchOut = (timeElapsed) => {
    return (
        <Widget styleName="gx-card-full gx-text-center gx-pt-4 gx-pb-3 gx-px-3">
            {/* <div className="gx-separator gx-bg-sepia" /> */}
            <Statistic className="gx-mb-2" title="Time Elapsed" value={<h1 className="gx-fs-xxl gx-font-weight-semi-bold gx-mb-1 ">{timeElapsed.hours()} H {timeElapsed.minutes()} M</h1>} />
            <h2 className="gx-mb-4 "></h2>

            <Button type='danger' onClick={logAttendence('punch_out')}>
                Punch Out
            </Button>
        </Widget>
    );
};
const logAttendence = (value) => {

    const endpoint = '/partner/partner-active-time/'
    const data = {
        is_active: value === 'punch_in' ? true : false,
        is_ended: value === 'punch_out' ? true : false,
    }
    createData(endpoint, data)
        .then(res => {
            if (res.data['status'] === 200) {
                value === 'punch_in' ? message.success("Punch In Successfully!") : message.success("Punch Out Successfully!")
            } else {
                value === 'punch_in' ? message.error("Error Punch In!") : message.success("Error Punch Out!")
            }
        }).catch(error => {
            console.log(error)
            message.error("Error Adding Attendence!")
        });

}

const AttendanceModal = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [attendance, setAttendance] = useState("");
    const [loading, setLoading] = useState(false);
    const [timeElapsed, setTimeElapsed] = useState('')



    const fetchAttendance = () => {
        let endpoint = '/partner/partner-active-time/'
        setLoading(true)
        getData(endpoint)
            .then(res => {
                if (res.data) {
                    setAttendance(res.data)
                    setLoading(false)
                } else {
                    setAttendance("")
                    setLoading(false)
                }
            }).catch(error => {
                setAttendance("")
                message.error("Error fetching Attendance!")
                setLoading(false)
            });
    }
    const showModal = () => {
        fetchAttendance()
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const { started_time,
        average_start_time,
        average_ended_time } = attendance

    // const timeElasped = () => {
    //     const currentDate = moment(new Date());
    //     const createDate = this.state.ticket.length !== 0 ? new Date(this.state.ticket[0].created) : moment(new Date());
    //     let ms = moment(currentDate, "DD/MM/YYYY HH:mm:ss").diff(moment(createDate, "DD/MM/YYYY HH:mm:ss"));
    //     let d = moment.duration(ms);
    //     let minutes = Math.floor(d / 60000);
    //     let hours = Math.round(minutes / 60);
    //     let days = Math.round(hours / 24);
    //     let s = Math.floor(d.asHours()) + moment.utc(ms).format(":mm:ss");
    //     // this.setState({ time_elapsed: d, days, hours, minutes })
    //     setTimeElapsed(d)
    // }

    //  setInterval(() => {
    //   timeElasped()
    // }, 60000);

    return (
        <>
            <a onClick={showModal}>
               Punch In/Out
            </a>
            <Modal title="Attendance" visible={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null}>
                <Row gutter={16}>
                    <Col span={24}>
                        <Statistic className="gx-mb-2" title="Today is" value={moment().format('dddd')} />
                    </Col>
                    <Col span={12}>
                        <PunchIn />
                    </Col>
                    <Col span={12}>
                        <PunchOut timeElapsed={timeElapsed} />
                    </Col>
                </Row>
            </Modal>
        </>
    );
};
export default AttendanceModal;